export { type RadioChangeEvent } from 'antd/lib/radio/interface';

import RadioOriginal from './Radio';
import RadioButton from './radio-button';
import RadioGroup from './radio-group';

const Radio = Object.assign(RadioOriginal, { Button: RadioButton, Group: RadioGroup });

export { Radio };
